<template>
  <v-card class="mb-4" outlined style="border-radius: 16px" v-if="customers.length">
    <v-card-title class="d-flex">
      <app-icon color="primary" class="mr-3">pending_actions</app-icon>
      Cadastros pendentes
    </v-card-title>
    <v-card-text>
      <v-list dense rounded>
        <v-list-item-group>
          <v-list-item v-for="(customer, i) in customers" :key="i" @click="openCustomer(customer.id)">
            <v-list-item-content>
              <v-list-item-title v-text="customer.name"></v-list-item-title>
              <v-list-item-subtitle>
                {{ $format.phone(customer.phone_wa) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="mr-2">
              <v-icon color="success" @click.stop="approve(customer)">
                mdi-check
              </v-icon>
            </v-list-item-action>
            <v-list-item-action>
              <v-icon @click.stop="reject(customer)">
                mdi-close
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
    <CustomerFormDialog ref="CustomerFormDialog" @store="fetchPendingCustomers()" />
    <RejectCustomerRegistrationDialog ref="RejectCustomerRegistrationDialog" @reject="handleRejected()" />
  </v-card>
</template>

<script>
import CustomerFormDialog from "@/components/v2/customers/forms/CustomerFormDialog.vue";
import RejectCustomerRegistrationDialog from "@/components/customers/sections/RejectCustomerRegistrationDialog.vue";

export default {
  components: {
    CustomerFormDialog,
    RejectCustomerRegistrationDialog,
  },

  data: () => ({
    customers: [],
  }),

  mounted() {
    this.fetchPendingCustomers();
  },

  methods: {
    fetchPendingCustomers() {
      this.$http.index("customer/customer-self-registration").then((response) => {
        this.customers = response.registrations.data;
      });
    },

    openCustomer(id) {
      this.$refs.CustomerFormDialog.open(id);
    },

    approve(customer) {
      this.$http
        .update("customer/customer-self-registration", customer.id, {
          status: "approved",
        })
        .then(() => {
          this.customers = this.customers.filter((c) => c.id !== customer.id);

          this.$snackbar({
            message: "Cadastro aprovado!",
            color: "success",
            timeout: 1000,
            showClose: false,
          });
        });
    },

    reject(customer) {
      this.$refs.RejectCustomerRegistrationDialog.open(customer);
    },

    handleRejected() {
      this.fetchPendingCustomers();

      this.$snackbar({
        message: "Cadastro rejeitado!",
        color: "success",
        timeout: 1000,
        showClose: false,
      });
    },
  },
};
</script>
<style></style>
